import React from 'react';

function Contact() {
  return (
    <div id="contact" className="col-12 text-center">
      <br />
      <div className="row text-center">
        <div className="col-12 text-center wow zoomIn">
          <div className="text-white mukta mb-2" style={{ display: 'inline-block' }}>
            <h1>
              <i className="fas fa-chevron-right"></i>
              <i className="fas fa-chevron-right"></i>
              &nbsp;Contacto&nbsp;
              <i className="fas fa-chevron-left"></i>
              <i className="fas fa-chevron-left"></i>
            </h1>
          </div>
        </div>
        <div className="col-12">
          <div className="col-12 text-center">
            <a 
              className="fa-stack fa-2x cursor mr-1 f-white"
              href="mailto:ineffableinventions@gmail.com?subject=Tengo una grandiosa idea&body=¡Hola! Tengo una grandiosa idea que quiero hacer realidad"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fas fa-envelope fa-stack-1x font-ineffable"></i>
            </a>

            <a 
              className="fa-stack fa-2x cursor mr-1 ml-1 f-white"
              href="https://wa.me/573106257871"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fab fa-whatsapp fa-stack-1x fa-lg font-ineffable"></i>
            </a>

            <a 
              className="fa-stack fa-2x cursor mr-1 ml-1 f-white"
              href="https://www.instagram.com/ineffableinventions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fab fa-instagram fa-stack-1x fa-lg font-ineffable"></i>
            </a>

            <a 
              className="fa-stack fa-2x cursor ml-1 f-white"
              href="https://www.facebook.com/IneffableInventions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className="fab fa-facebook-f fa-stack-1x font-ineffable"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="col-12">
        <br />
      </div>
    </div>
  );
}

export default Contact;
